import "@common/jquery.ext";
import Cookies from "js-cookie";
import {ajax} from "@common/ajax";
import {menu} from "@common/menu";
import {util} from "@common/util";
import {alert} from "@common/message";
import {NewPasswordPopup} from "@components/popup/password.new";
import {setOAuthCallback} from "@common/store";

const mCookieName = "oms-remember-id";
let mNewPwPopup: NewPasswordPopup;
$(() => {
    // popup
    mNewPwPopup = new NewPasswordPopup();
    // events
    $("#mbrId").enter("#mbrPw");
    $("#mbrPw").enter(doLogin);
    $("#btnLogin").click(doLogin);
    $("#btnGoogle").click(menu.openOAuthGoogle);
    $("#btnNaver").click(menu.openOAuthNaver);
    $("#btnKakao").click(menu.openOAuthKakao);
    // oauth callback method
    setOAuthCallback(oauthCallback);
    // cookie
    const mbrId = Cookies.get(mCookieName);
    if (!!mbrId) {
        $("#mbrId").val(mbrId);
        $("#rememberId").prop("checked", true);
    }

    // shortcut
    initShortcut();
});

const doLogin = (): void => {
    // hide message
    hideMessage();

    // check valid
    if ($("#mbrId").trim().val() === "") {
        showMessage("아이디를 입력해 주세요.");
        $("#mbrId").focus();
    }
    else if ($("#mbrPw").val() === "") {
        showMessage("비밀번호를 입력해 주세요.");
        $("#mbrPw").focus();
    }
    else {
        if ($("#rememberId").isCheck()) {
            const mbrId = $("#mbrId").val();
            Cookies.set(mCookieName, `${mbrId}`, { expires: 604800 });
        }
        else {
            Cookies.remove(mCookieName);
        }

        ajax.formSubmit({
            url: "./loginProc.do",
            form: "#frmLogin",
            func: {
                success: loginSuccess,
                error: (result: any) => {
                    if (util.equals(result.code, 5)) {
                        openNewPasswordPopup();
                    }
                    else {
                        let message = ajax.getErrorMessage(result, [
                            { code: 1, message: "회원 정보를 찾을 수 없습니다." },
                            { code: 2, message: "아이디 또는 비밀번호를 잘못 입력했습니다." },
                            { code: 3, message: "가입 승인되지 않은 계정입니다." },
                            { code: 4, message: "사용할 수 없는 계정입니다." },
                            { code: 9, message: "로그인에 실패하였습니다." },
                        ]);
                        showMessage(message);
                    }
                }
            }
        });
    }
}

const loginSuccess = (result: any): void => {
    if (result.returnUrl) {
        menu.go(result.returnUrl, true);
    }
    else {
        menu.goHomeReplace();
    }
}

const openNewPasswordPopup = (): void => {
    $("#mbrPw").val("");
    mNewPwPopup.open($("#mbrId").val(), () => {
        alert("비밀번호가 변경되었습니다.<br/>다시 로그인해 주세요.", () => {
            $("#mbrPw").focus();
        });
    });
}

const oauthCallback = (result: any): void => {
    if (!!result) {
        if (util.equals(result.code, 0)) {
            loginSuccess(result);
        }
        else if (util.equals(result.code, 11)) {
            alert("간편 로그인 연동된 계정이 없습니다.<br/>로그인 후 마이페이지에서 간편 로그인 연동을 확인해 주세요.");
        }
        else {
            alert("간편 로그인 인증에 실패하였습니다.");
        }
    }
}

const showMessage = (message: string): void => {
    $(".account-message").html(message).show();
}

const hideMessage = (): void => {
    $(".account-message").html("");
}

//-----------------------------------------
// shortcut
//-----------------------------------------
let mDeferredPrompt: any = null;
const initShortcut = (): void => {
    if (util.isMobile()) {
        // service worker
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.register(`${menu.getAssetPath()}pwa/pwa.js`);
        }
        // events
        $("#btnShortcutSubmit").click(doShortcut);
        $("#btnShortcutCancel").click(closeShortcut);
        // prompt
        window.addEventListener("beforeinstallprompt", (event: any): void => {
            event.preventDefault();
            mDeferredPrompt = event;
            openShortcut();
        });
    }
}

const openShortcut = (): void => {
    $("#shortcut").show().addClass("on");
}

const closeShortcut = (): void => {
    $("#shortcut").removeClass("on");
}

const doShortcut = (event: any): void => {
    event.preventDefault();
    if (mDeferredPrompt) {
        mDeferredPrompt.prompt();
        mDeferredPrompt.userChoice.then((choiceResult: any) => {
            if (choiceResult.outcome === "accepted") {
                mDeferredPrompt = null;
                closeShortcut();
                alert("설정이 완료되었습니다.<br/>이제 홈 화면에서 바로 이용하실 수 있습니다.");
            }
        });
    }
}